import { Card } from '@snack-uikit/card';
import { TruncateString } from '@snack-uikit/truncate-string';
import { Typography } from '@snack-uikit/typography';
import { type MouseEvent } from 'react';
import { useWindowWidth } from 'src/hooks/useWindowWidth';
import { type CatalogProduct } from 'src/types/backendContent';

import { ProductTags } from '../ProductTags';
import s from './CardProduct.module.scss';

const DEFAULT_ICON = '/svg/components/ProductsCatalog/icon.svg';

export type CardClickHandler = (params: {
  e: MouseEvent<HTMLAnchorElement>;
  href: string;
  title: string;
  source: CatalogProduct['analyticSource'];
}) => void;

type CardProductProps = Pick<
  CatalogProduct,
  'title' | 'description' | 'icon' | 'analyticSource' | 'tags'
> & {
  onClick: CardClickHandler;
  href: string;
};

export function CardProduct({
  title,
  description,
  icon,
  analyticSource,
  tags,
  onClick,
  href,
}: CardProductProps) {
  // TODO: Заменить на хук из uikit-product, когда починят
  const { windowWidth } = useWindowWidth();

  const filteredTags = tags?.length
    ? tags.filter((tag) => !tag.hideInCatalog)
    : [];

  const isNotDesktop = windowWidth && windowWidth < 1024;

  const Title = isNotDesktop ? Typography.SansLabelL : Typography.SansTitleM;

  const Description = Typography.SansBodyM;

  return (
    <Card
      size="m"
      href={href}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        onClick({ e, title, href, source: analyticSource });
      }}
    >
      <div className={s.root}>
        <div className={s.iconContainer}>
          <img
            className={s.icon}
            src={icon || DEFAULT_ICON}
            alt={`Иконка-${title}`}
            width={24}
            height={24}
          />
        </div>
        <div className={s.body}>
          <Title className={s.title} tag="h3">
            <TruncateString text={title} maxLines={2} />
          </Title>
          {description && (
            <Description className={s.description}>
              <TruncateString text={description} maxLines={3} />
            </Description>
          )}
          {filteredTags?.length ? (
            <div className={s.tags}>
              <ProductTags
                tagClassName={s.tag}
                tags={filteredTags}
                length={2}
              />
            </div>
          ) : null}
        </div>
      </div>
    </Card>
  );
}
